/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pre_Render_Frame_Cache_Progress_Aria_LabelInputs */



/**
* | output |
* | --- |
* | "Pre-render frame cache progress" |
*
* @param {Pre_Render_Frame_Cache_Progress_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const pre_render_frame_cache_progress_aria_label = /** @type {((inputs?: Pre_Render_Frame_Cache_Progress_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pre_Render_Frame_Cache_Progress_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Progression de la pré-génération du cache d'images")
	if (locale === "de") return /** @type {LocalizedString} */ ("Fortschritt des Vorrender-Frame-Caches")
	if (locale === "it") return /** @type {LocalizedString} */ ("Avanzamento della cache dei frame di pre-rendering")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Ход обработки кэша кадров перед рендерингом")
	if (locale === "es") return /** @type {LocalizedString} */ ("Progreso de precarga de caché de fotogramas")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("预渲染帧缓存进度")
	if (locale === "ja") return /** @type {LocalizedString} */ ("プリレンダリングフレームキャッシュの進行状況")
	if (locale === "hi") return /** @type {LocalizedString} */ ("प्री-रेंडर फ्रेम कैश प्रगति")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Progresso do cache de quadros pré-renderizados")
	return /** @type {LocalizedString} */ ("Pre-render frame cache progress")
});